import { gql, useQuery } from '@apollo/client';
import type { BookingFilters } from '__generated__/globalTypes';
import type {
  getAvailableBookingDates,
  getAvailableBookingDatesVariables,
} from './__generated__/getAvailableBookingDates';

export const GET_DATES = gql`
  query getAvailableBookingDates(
    $serviceId: ID!
    $emailAddress: String!
    $filters: BookingFilters!
  ) {
    availableBookingDates(
      input: {
        serviceId: $serviceId
        emailAddress: $emailAddress
        filters: $filters
      }
    ) {
      availableDates
    }
  }
`;

export const useGetDates = (
  serviceId: string,
  emailAddress: string,
  filters: BookingFilters,
) => {
  const { data, loading, error } = useQuery<
    getAvailableBookingDates,
    getAvailableBookingDatesVariables
  >(GET_DATES, {
    variables: { serviceId, emailAddress, filters },
    errorPolicy: 'all',
    returnPartialData: false,
  });

  return { data, loading, error };
};
